import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-indicador-card',
  templateUrl: './indicador-card.component.html',
  styleUrls: ['./indicador-card.component.scss']
})
export class IndicadorCardComponent {
  @Input() icon: string = '';
  @Input() label: string = '';
  @Input() value: string | number = '';
  @Input() suffix?: string = '';
}
